import { findPort } from '../../trace/ports.js';
import { defineRule } from '../rule.js';

/** E: more than one cable ends on the same input port. */
export const inputDoubleBooked = defineRule(
  'input-double-booked',
  'error',
  { en: 'Input used twice', de: 'Eingang doppelt belegt' },
  (data, emit) => {
    const byPort = new Map<string, { itemId: string; portId: string; connectionIds: string[] }>();
    for (const c of Object.values(data.connections)) {
      for (const end of [c.from, c.to]) {
        if (findPort(data, end.itemId, end.portId)?.direction !== 'in') continue;
        const key = JSON.stringify([end.itemId, end.portId]);
        const entry = byPort.get(key) ?? { ...end, connectionIds: [] };
        entry.connectionIds.push(c.id);
        byPort.set(key, entry);
      }
    }
    return [...byPort.values()]
      .filter((e) => e.connectionIds.length > 1)
      .map((e) =>
        emit([e.itemId, ...e.connectionIds], {
          port: findPort(data, e.itemId, e.portId)!.name,
          count: e.connectionIds.length,
        }),
      );
  },
);
